export class TranslationData {
    public data: any = [];
    public user_updated: string = "";
    public updated_at: string = "";
}